<script setup lang="ts">
import Chart from 'primevue/chart';
import Legend from '@/components/Legend';
import { storeToRefs } from 'pinia';
import { useAttendanceStore } from '@/store';
import { onMounted, ref, watch } from 'vue';
import { AttendanceResults } from '@/types';

const AttendanceStore = useAttendanceStore();
const { results } = storeToRefs(AttendanceStore);
const primeChart = ref();

interface LabelInterface {
  total: string;
  title: string;
  color: string;
}
const chartData = {
  datasets: [
    {
      backgroundColor: [] as string[],
      labels: [] as LabelInterface[],
      data: [] as string[],
    },
  ],
};

const colors = {
  ['Present']: '#045C5C',
  ['No Show']: '#94703C',
  ['Absent']: '#94703C',
  ['Late Cancel']: '#474299',
  ['Service Provider Cancelled']: '#7F3666',
  ['No School']: '#26728E',
  ['Customer Cancelled']: '#C3370b',
};

function getAttendanceData(): void {
  chartData.datasets[0].data = [];
  chartData.datasets[0].backgroundColor = [];
  chartData.datasets[0].labels = [];

  results.value
    .sort((a, b) => (a.count < b.count ? 1 : -1))
    .map((result: AttendanceResults) => {
      chartData.datasets[0].data.push(result?.count);
      chartData.datasets[0].backgroundColor.push(colors[result?.name] as string);
      chartData.datasets[0].labels.push({
        total: result.count.toString(),
        title: result.name,
        color: colors[result.name] as string,
      });
    });

  if (!primeChart.value?.chart?.data) {
    return;
  }

  const chart = primeChart.value.chart;
  chart.data = chartData;
  chart.update();
}

onMounted(() => {
  getAttendanceData();
});

watch(results, () => {
  getAttendanceData();
});
</script>

<template>
  <div class="fadein grid p-0 mt-3">
    <template v-if="results.every((result) => result.count === 0)">
      <p class="text-center mb-3 w-full">No data to view.</p>
    </template>
    <div v-else class="w-full">
      <div class="m-0 p-0 flex">
        <div class="chart col-fixed m-0 p-0 pb-1">
          <Chart ref="primeChart" type="doughnut" :data="chartData" />
        </div>
        <Legend :labels="chartData?.datasets[0].labels" class="legend" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.chart {
  width: 100px;
  height: 100px;
}
.legend {
  width: 200px;
  .total {
    width: 20px;
  }
}
</style>
